var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'app-form-section-block': true, 'no-margin': _vm.noMargin}},[(_vm.icon)?_c('div',{staticClass:"app-form-section-block-icon"},[_c('v-icon',{attrs:{"color":"quaternary","size":"20"}},[_vm._v(_vm._s(_vm.icon))])],1):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }